export default "__VITE_ASSET__DX9dVH4B__"